import React, { useState, useEffect } from "react"
import { auth } from "../../firebase"
import axios from "axios"
import { Image } from "primereact/image"
import { useUserContext } from "../../context/usercontext"
import { Button } from "primereact/button"
import GLOBAL from "../../config/variable"

function ShareCodigo() {
  const { user, userData } = useUserContext()
  const [copied, setCopied] = useState(false)
  const [QR, setQR] = useState(null)

  useEffect(() => {
    try {
      const fetchReferralCode = async () => {
        if (!userData?.referral_code) return // Asegura que esté definido antes de llamar
        const response = await axios.get(
          `${GLOBAL.SERVER_URL}/users/referral/${userData.referral_code}/qr`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        )
        if (response.data.success) {
          setQR(response.data)
        }
      }

      fetchReferralCode()
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirigir al login si la respuesta es 401
        auth.signOut()
      }
      console.error("Error fetching QR code:", error)
    }
  }, [userData.referral_code, user.accessToken])

  if (!userData) {
    return <div>Cargando...</div>
  }
  return (
    <div className="flex flex-column align-items-center justify-content-center">
      <h2 className="text-2xl text-center text-white mt-2">
        Tu código de referrencia: <strong>{userData.referral_code}</strong>
      </h2>
      <div className="flex flex-column gap-2 justify-content-center ">
        <p className="text-white text-sm text-center">
          Comparte tu código con tus amigos y recibe puntos por cada referido.
        </p>
      </div>
      {QR && (
        <div className="flex flex-column gap-2 justify-content-center xl:my-4">
          <Image src={QR.data.qrCodeImage} alt="QR" />
        </div>
      )}
      <div className="flex  gap-1 justify-content-center align-items-center ml-4 mb-4 xl:ml-0">
        <p className="text-white text-sm text-center">Presiona</p>
        {QR && (
          <Button
            className="p-0 m-0 bg-transparent border-0 text-sm cursor-pointer"
            style={{
              all: "unset",
              color: "var(--secondary-color)",
              textDecoration: "underline",
            }}
            onClick={() => {
              navigator.clipboard.writeText(QR.data.registrationUrl)
              setCopied(true)
              // Push successful QR code copy event to dataLayer
              window.dataLayer.push({
                event: 'qr_code_copied',
                user_id: user.uid,
                user_email: userData.email
              })
            }}
            label="Aquí"
          />
        )}
        <p className="text-white text-sm text-center">
          para compartir tu código
        </p>
      </div>
      {copied && (
        <p className="text-white text-sm text-center">
          Código copiado al portapapeles
        </p>
      )}
    </div>
  )
}

export default ShareCodigo
